/**
 * formatAuditDate — pure formatter for the record audit footer (RuntimeFormRenderer).
 *
 * Accepts whatever the record's created_at/updated_at fields carry (an ISO
 * timestamp string in practice) and returns a short locale date, or '' when
 * the value is missing or unparseable — the footer omits that part rather
 * than rendering "Invalid Date".
 */
export function formatAuditDate(value: unknown): string {
  if (value === null || value === undefined || value === '') return ''
  if (typeof value !== 'string' && typeof value !== 'number') return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit' })
}
